import React, { Component } from 'react';
import styled from 'styled-components';
import Link from 'gatsby-link';
import {
  Phone,
  Email,
  SplitSection,
  LeftSection,
  RightSection,
  TeamImage,
  TeamList,
  TeamListItem,
  TeamListItemGrey
} from '../../static/styles/styles';
import Navigation from '../../componenten/Navigation';
import HulpiaArchitectenComp from '../../componenten/HulpiaArchitectenComp';

const Sticky = styled.div`
  position: sticky;
  background-color: #fff;
  top: 160px;
  z-index: 3;
`;

class TeamPage extends Component {
  render() {
    const teamItems = this.props.data.allTeamJson.edges[0].node.team;
    const teamImage = this.props.data.allTeamJson.edges[0].node.teamImage;
    const navItems = this.props.data.allNavigationJson.edges;
    const subNavContact = navItems.filter(
      ({ node: navItem }, index) => index === 1
    );

    return (
      <div>
        <Sticky>
          <Navigation items={subNavContact} navType="sub" />
        </Sticky>

        <SplitSection>
          <LeftSection>
            <HulpiaArchitectenComp />
            <TeamImage src={teamImage} alt="" />
          </LeftSection>
          <RightSection>
            {teamItems.map(({ naam, functie, telefoon, email }, index) => {
              return (
                <TeamList key={index}>
                  <TeamListItem>
                    {naam} — {functie}
                  </TeamListItem>
                  <TeamListItemGrey>
                    <Phone href={`tel:${telefoon}`}>{telefoon}</Phone>
                  </TeamListItemGrey>
                  <TeamListItemGrey>
                    <Email href={`mailto:${email}`}>{email}</Email>
                  </TeamListItemGrey>
                </TeamList>
              );
            })}
          </RightSection>
        </SplitSection>
      </div>
    );
  }
}

export const pageQuery = graphql`
  query TeamPageQuery {
    allNavigationJson {
      edges {
        node {
          to
          name
          key
          sub
          subItems {
            to
            name
            key
          }
        }
      }
    }
    allTeamJson {
      edges {
        node {
          teamImage
          team {
            naam
            functie
            telefoon
            email
          }
        }
      }
    }
  }
`;

export default TeamPage;



// WEBPACK FOOTER //
// ./src/pages/contact/team.js